import { defineComponent as u, useSlots as c, useCssModule as d, computed as l, createElementBlock as h, openBlock as v, normalizeStyle as f, normalizeClass as p, unref as n, renderSlot as _ } from "vue";
import { _ as x } from "./_plugin-vue_export-helper-CHgC5LLL.js";
var m = /* @__PURE__ */ ((e) => (e.Text = "text", e.Circular = "circular", e.Rectangular = "rectangular", e))(m || {});
const w = /* @__PURE__ */ u({
  __name: "Skeleton",
  props: {
    height: { default: void 0 },
    variant: {
      default: "text"
      /* Text */
    },
    width: { default: void 0 }
  },
  setup(e) {
    const t = e, o = c(), r = d(), a = l(() => !!o.default), i = l(() => {
      const s = {};
      return t.width && (s.width = `${t.width}px`), t.height && t.variant !== "text" && (s.height = `${t.height}px`), s;
    });
    return (s, y) => (v(), h("div", {
      "data-test": "stash-skeleton",
      class: p(["stash-skeleton tw-animate-pulse tw-bg-ice-500", {
        "stash-skeleton--circular tw-rounded-full": t.variant === "circular",
        "stash-skeleton--text tw-rounded": t.variant === "text",
        [n(r)["text-variant"]]: t.variant === "text",
        "stash-skeleton--rectangular tw-rounded": t.variant === "rectangular",
        [n(r)["has-children"]]: a.value,
        "tw-max-w-fit": a.value && !t.width,
        "tw-h-auto": a.value && !t.height
      }]),
      style: f(i.value)
    }, [
      _(s.$slots, "default")
    ], 6));
  }
}), g = {
  "text-variant": "_text-variant_buk08_2",
  "has-children": "_has-children_buk08_6"
}, k = {
  $style: g
}, $ = /* @__PURE__ */ x(w, [["__cssModules", k]]);
export {
  m as SkeletonVariants,
  $ as default
};
//# sourceMappingURL=Skeleton.js.map
